import { render, staticRenderFns } from "./opened.vue?vue&type=template&id=0a1a6f1a&scoped=true&lang=pug&"
import script from "./opened.vue?vue&type=script&lang=js&"
export * from "./opened.vue?vue&type=script&lang=js&"
import style0 from "./opened.vue?vue&type=style&index=0&id=0a1a6f1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a6f1a",
  null
  
)

export default component.exports